export default __webpack_public_path__ + "static/blob7-9582284e83edc310a799cbc1573001d7.svg";